import { render, staticRenderFns } from "./DashEtfTop.vue?vue&type=template&id=22611d87&scoped=true"
import script from "./DashEtfTop.vue?vue&type=script&lang=js"
export * from "./DashEtfTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22611d87",
  null
  
)

export default component.exports